module.exports = __webpack_public_path__ + "static/media/menu-healtheat.997b02a4.png";